// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__8jU_S","isActive":"Button_isActive__YpCXl","dark":"Button_dark__rfOCg","badge":"Button_badge__fpdzr"};